import { Lightning, Router } from '@lightningjs/sdk'

import { black, getColor, grey300, grey50, grey920, white } from '../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../constants/fonts'
import { Images } from '../constants/paths'
import { getText } from '../utils/dictionary'
import { getAsset } from '../utils/image'
import { generateQR } from '../utils/misc'
import { captureScreenData, NON_BFF_SEGMENT_SCREENS } from '../utils/segmentAnalytics'

export default class ChangePassword extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey920),
      flex: {
        direction: 'column',
      },
      Header: {
        w: (w) => w,
        h: 168,
        rect: true,
        color: getColor(black),
        Logo: {
          x: 73,
          y: 70,
          h: 29,
          w: 246,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.LOGO_LARGE), 256, 29),
        },
      },
      Container: {
        w: (w) => w,
        h: 912,
        y: 80,
        rect: true,
        color: getColor(grey920),
        flex: {
          direction: 'column',
          alignItems: 'center',
        },
        Title: {
          text: {
            text: getText('changePasswordModalTitle'),
            fontSize: 48,
            lineHeight: 48,
            fontFace: UniNeueBold,
            textColor: getColor(white),
          },
          flexItem: {
            marginBottom: 32,
          },
        },
        QrCodeContainer: {
          flex: { direction: 'row', alignItems: 'center' },
          QRCode: {
            w: 244,
            h: 244,
            rect: true,
            color: getColor(grey50),
            shader: null,
            src: '',
            flexItem: { marginRight: 32 },
          },
          Description: {
            text: {
              text: getText('changePasswordModalDesc'),
              fontSize: 24,
              fontFace: UniNeueRegular,
              textColor: getColor(grey300),
              lineHeight: 34,
              wordWrapWidth: 390,
              maxLines: 4,
              maxLinesSuffix: '...',
            },
          },
        },
      },
    }
  }

  get qrCode() {
    return this.tag('QRCode')
  }

  async _init() {
    await this.setQR(getText('changePasswordUrl'))
  }

  _focus() {
    this.visible = true
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.ChangePassowrd)
  }

  _handleKey() {
    // Prevent modal from trying to focus somewhere else
    return true
  }

  _handleBack(event) {
    event.preventDefault()

    this.refocusPage()
  }

  refocusPage() {
    this.visible = false

    Router.focusPage()
  }

  async setQR(textToQr: string) {
    this.qrCode.patch({ src: await generateQR(textToQr) })
  }
}
